import React from "react";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import RemoveSupplyPublicAgreementGas from "./RemoveSupplyPublicAgreementGas";
import RemoveSupplyPublicForm from "./RemoveSupplyPublicForm";
import { useRemoveSupplyPublicForm } from "./hooks/useRemoveSupplyPublicForm";
import { Text } from "@origin-digital/ods-core";
import { SupplyConfigurationType } from "./hooks/type";
import { getPublicRemoveSupplySuccessUrl } from "src/utils/routeUtils";

export const gasSupplyConfiguration: SupplyConfigurationType = {
  initialFormData: {
    journeyId: "",
    postcode: "",
    scheduleDate: null,
    meterNumber: "",
    mirn: "",
  },
  createSetFormDataAction: (idValue) => (prev) => ({
    ...prev,
    mirn: idValue,
  }),
  getSuccessUrl: () => getPublicRemoveSupplySuccessUrl("gas"),
};

export const RemoveSupplyPublicFormGas: React.FC = () => {
  const hookProps = useRemoveSupplyPublicForm(gasSupplyConfiguration);
  return (
    <RemoveSupplyPublicForm
      {...hookProps}
      agreement={<RemoveSupplyPublicAgreementGas feeInfo={hookProps.feeInfo} />}
      nmiOrMirnField={
        <ReadOnlyTextField label="MIRN" value={hookProps.formData.mirn} />
      }
      instructionText={
        <Text>
          To proceed with the permanent disconnection of the gas meter and
          supply, please enter the reference number and the postcode of the
          property in question. You can find these details in the email/SMS
          you've received.
        </Text>
      }
    />
  );
};
